var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_345045)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0234375,
    width: 16,
    height: 16,
    fill: "#5EAAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02344 8L7.02344 11L12.0234 5",
    stroke: "#E8ECF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02344 1H12.0234V-1H4.02344V1ZM15.0234 4V12H17.0234V4H15.0234ZM12.0234 15H4.02344V17H12.0234V15ZM1.02344 12V4H-0.976562V12H1.02344ZM4.02344 15C2.36658 15 1.02344 13.6569 1.02344 12H-0.976562C-0.976562 14.7614 1.26201 17 4.02344 17V15ZM15.0234 12C15.0234 13.6569 13.6803 15 12.0234 15V17C14.7849 17 17.0234 14.7614 17.0234 12H15.0234ZM12.0234 1C13.6803 1 15.0234 2.34315 15.0234 4H17.0234C17.0234 1.23858 14.7849 -1 12.0234 -1V1ZM4.02344 -1C1.26201 -1 -0.976562 1.23858 -0.976562 4H1.02344C1.02344 2.34315 2.36658 1 4.02344 1V-1Z",
    fill: "#9AAAB5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_345045"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 4C0.0234375 1.79086 1.8143 0 4.02344 0H12.0234C14.2326 0 16.0234 1.79086 16.0234 4V12C16.0234 14.2091 14.2326 16 12.0234 16H4.02344C1.8143 16 0.0234375 14.2091 0.0234375 12V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.2134f44486eecd44fdf1b3c98584f0b9.svg";
export { ForwardRef as ReactComponent };